import styled from "@emotion/styled";
import { selectV2Theme } from "../selectV2Theme";
export const ContentBeforeContainer = styled("div")`
    width: ${_ref => {
  let {
    themeMode
  } = _ref;
  return selectV2Theme.contentBefore.width(themeMode);
}};
    display: flex;
    align-self: var(--sds--content--before--container--align-self);
    align-items: center;
    justify-content: center;
    flex: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return selectV2Theme.contentBefore.flex(themeMode);
}};
    margin-top: var(--sds--content--before--container--margin-top, -1px);
`;
//# sourceMappingURL=ContentBeforeContainer.js.map